import React, { useCallback } from "react"
import { StyleSheet } from "~/ui/primitives"
import { observer } from "mobx-react-lite"
import { useTheme } from '~/ui/styled'
import {
  StartFlex,
  ColumnFlex,
  CenterFlex,
  Text,
  BetweenFlex,
  IconFont,
  Button,
} from "~components/El"
import QrcodeGroup from "~components/qrcode-group"
import useNavigation from "~hooks/useNavigation"
import { ChatPerms } from "~proto"
import { useStores } from "~models"
import { Avatar, PreviewAvatar } from "~widgets/avatar"
import { formatDate, copyText } from "~utils"
import { usePopup } from "~hooks/usePopup"
import { ChannelChatInformationScreenProps} from "./types"

// const ChatPermsLabel: Record<ChatPerms, string> = {
//   [ChatPerms.ADMIN]: "频道创建者",
//   [ChatPerms.SUB_ADMIN]: "管理员"
// }

const ChannelChatInformation: React.FC<ChannelChatInformationScreenProps> = () => {
  const theme = useTheme()
  const navigation = useNavigation()
  const { chatStore } = useStores()
  const popup = usePopup()
  const { current } = chatStore
  // const [isTop, setIsTop] = useState(false)
  
  const members = current?.members.filter(item => [ChatPerms.ADMIN, ChatPerms.SUB_ADMIN].includes(item.perm))
//   console.log(current, "current")

  // 频道二维码
  const openQrcodeModal = useCallback(() => {
    popup.open({
      type: "center",
      width: "100%",
      content: () => React.createElement(QrcodeGroup, { current }),
    })
  }, [current, popup])

  return (
    <ColumnFlex width="100%"  bg={theme.colors.background}>
      <CenterFlex height="auto" flexDirection="column" width="100%" padding="15px" bg={theme.colors.blockBackground}>
        <PreviewAvatar size={60} avatar={current?.image} name={current?.title}/>
        <Text color={theme.colors.text} fontSize={18} fontWeight={600} padding="15px 0">{current?.title}</Text>
       
        <Button flexDirection="row" padding="3px 0" onClick={() => copyText(current?.name)}>
        <Text color={theme.colors.primaryText} fontSize={12}>{current?.name || current?.chat_id || ""}</Text>
          <IconFont name="copy" size={12} color={theme.colors.primaryText} />
        </Button>
        <Button
          flexDirection="row"
          width="120px"
          height="30px"
          margin="15px 0"
          borderRadius="6px"
          bg={theme.colors.primary}
          onClick={openQrcodeModal}
        >
            <IconFont name="ewm" size={12} color={theme.colors.textLight} />
            <Text color={theme.colors.textLight} fontSize={14} ml="5px">频道二维码</Text>
        </Button>
        <Text color={theme.colors.secondary} fontSize={14}>{current?.members?.length} 订阅者&nbsp;&nbsp;&nbsp;创建于 {formatDate(current.created)}</Text>
      </CenterFlex>
      <ColumnFlex height="auto" width="100%" padding="15px" mt="10px" bg={theme.colors.blockBackground}>
        <Text color={theme.colors.text} fontSize={16} fontWeight={600}>频道简介</Text>
        <Text
          numberOfLines={2}
          color={theme.colors.secondary}
          fontSize={12}
          mt="10px"
          onClick={() =>
            navigation.navigate("GroupAnnouncementDetail", {
              chat_id: current?.chat_id,
              title: "频道简介",
            })
          }
        >{current?.desc || "暂无简介"}</Text>
      </ColumnFlex>
      <ColumnFlex height="auto" width="100%" padding="15px" mt="10px" bg={theme.colors.blockBackground}>
        <BetweenFlex width="100%">
            <Text color={theme.colors.text} fontSize={16} fontWeight={600}>频道管理员</Text>
            <Text color={theme.colors.secondary} fontSize={14}>{members.length}人</Text>
        </BetweenFlex>
        <StartFlex height="auto" width="100%" mt="10px" gap="10px">
            {members.map((item, index) => (
                <CenterFlex height="auto" width="auto" flexDirection="column" key={index}>
                    <CenterFlex height="auto" width="auto" position="relative">
                        <Avatar size={40} avatar={item.user?.avatar} name={item.user?.name}/>
                        <CenterFlex
                            position="absolute"
                            right="-4px"
                            top="-4px"
                            width="16px"
                            height="16px"
                            borderRadius="8px"
                            bg={theme.colors.warning}
                        >
                            {item.perm === ChatPerms.ADMIN && (<IconFont name="a-Frame1561999599" color="#fff" size={8} />)}
                            {item.perm === ChatPerms.SUB_ADMIN && (<IconFont name="a-Frame1561999596" color="#fff" size={8} />)}
                        </CenterFlex>
                    </CenterFlex>
                    <Text color={theme.colors.secondary} fontSize={12} mt="6px">{item.user?.name}</Text>
                </CenterFlex>
            ))}
        </StartFlex>
      </ColumnFlex>
      <ColumnFlex height="auto" width="100%" padding="0 15px" mt="10px" bg={theme.colors.blockBackground}>
        <Button
            flexDirection="row"
            alignItems="center"
            justifyContent="space-between"
            width="100%"
            height="48px"
            borderBottomWidth={StyleSheet.hairlineWidth}
            borderBottomColor={theme.colors.border}
            borderBottomStyle="solid"
            onClick={() => {
              navigation.navigate("SearchChatContent", { chat_cid: current?.chat_cid })
            }}
        >
            <StartFlex>
                <IconFont name="ss" color={theme.colors.text} size={14} />
                <Text fontSize="14px" color={theme.colors.text} ml="8px">查找聊天内容</Text>
            </StartFlex>
            <IconFont name="right" color={theme.colors.secondaryText} size={14} />
        </Button>
        {/* <Button
            flexDirection="row"
            alignItems="center"
            justifyContent="space-between"
            width="100%"
            height="48px"
            onClick={() => {
            }}
        >
            <StartFlex>
                <IconFont name="shaixuan" color={theme.colors.text} size={14} />
                <Text fontSize="14px" color={theme.colors.text} ml="8px">置顶聊天</Text>
            </StartFlex>
            <CenterFlex pr="10px">
                <Switch value={isTop} onValueChange={setIsTop} />
            </CenterFlex>
        </Button> */}
      </ColumnFlex>
    </ColumnFlex>
  )
}

export default observer(ChannelChatInformation)
